import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPodcasts } from '../services/api';
import { useLanguage } from '../contexts/LanguageContext';
import { Headphones, Play } from 'lucide-react';

export default function PodcastListPage() {
  const { isKannada } = useLanguage();
  const [podcasts, setPodcasts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPodcasts({ limit: 50, status: 'published' })
      .then(r => setPodcasts(r?.data?.podcasts || []))
      .catch(() => setPodcasts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-[#f8f8f8] min-h-screen" data-testid="podcasts-list-page">
      <div className="max-w-[1400px] mx-auto px-4 py-8">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-12 h-12 rounded-2xl bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center">
            <Headphones className="w-6 h-6 text-white" />
          </span>
          <div>
            <h1 className="text-3xl font-black text-[#1a1a1a] font-kannada">{isKannada ? 'ಪಾಡ್‌ಕಾಸ್ಟ್‌ಗಳು' : 'Podcasts'}</h1>
            <p className="text-sm text-gray-500">{isKannada ? 'ಎಲ್ಲಾ ಸಂಚಿಕೆಗಳು' : 'All episodes'}</p>
          </div>
        </div>

        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {[1,2,3,4,5,6].map(i => <div key={i} className="bg-white rounded-xl aspect-square animate-pulse" />)}
          </div>
        ) : podcasts.length === 0 ? (
          <p className="text-center text-gray-500 py-16">{isKannada ? 'ಯಾವುದೇ ಪಾಡ್‌ಕಾಸ್ಟ್‌ಗಳಿಲ್ಲ.' : 'No podcasts yet.'}</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
            {podcasts.map(p => (
              <Link key={p.podcast_id} to={`/podcast/${p.podcast_id}`} className="group bg-white border border-gray-100 rounded-xl overflow-hidden hover:shadow-lg transition-shadow" data-testid={`podcast-list-${p.podcast_id}`}>
                <div className="relative">
                  {p.thumbnail ? (
                    <img src={p.thumbnail} alt="" className="w-full aspect-square object-cover" />
                  ) : (
                    <div className="w-full aspect-square bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
                      <Headphones className="w-12 h-12 text-white/70" />
                    </div>
                  )}
                  <div className="absolute bottom-2 right-2 w-10 h-10 rounded-full bg-purple-600 text-white flex items-center justify-center shadow group-hover:scale-110 transition-transform">
                    <Play className="w-4 h-4 ml-0.5" fill="currentColor" />
                  </div>
                </div>
                <div className="p-3">
                  <h3 className="text-[14px] font-bold text-[#1a1a1a] line-clamp-2 leading-snug font-kannada group-hover:text-purple-600 transition-colors">{isKannada ? (p.title_kn || p.title) : p.title}</h3>
                  {p.duration && <span className="text-[11px] text-gray-400 mt-1 block">{p.duration}</span>}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
